import React from 'react'

interface TickIconProps {
    width?: number;
    height?: number;
    color?: string;
}

export const TickIcon = ({ width = 24, height = 24, color = "#1A1A1A" }: TickIconProps) => {
    return (
        <svg fill="none" height={height} viewBox="0 0 24 24" width={width} xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20 6L9 17L4 12"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
            />
        </svg>
    )
}
